import React from "react";
import "../components/MacWindow.css";
import Draggable from "react-draggable";
import Container from "react-bootstrap/Container";
// import './draggable.js';

export default function AboutMe({ onClose }) {
  return (
    <Draggable handle=".windowheader">
      <div className="draggable-container">
        <div class="window about">
          <div class="windowheader" id="dragzone">
            <div class="wrapper">
              <div class="nav-buttons">
                <div class="close" onClick={onClose}></div>
                <div class="minimize"></div>
                <div class="expand"></div>
              </div>
              <div class="title">About Me</div>
            </div>
          </div>

          <div class="body about">
            <Container
              style={{ maxHeight: "465px", overflowY: "auto" }}
              id="style-1"
              className="scrollbar"
            >
              <div className="text">
                <h2>About ME</h2>
                <p>
                  Computer Science student who is equipped with a diverse
                  technical skill set and a passion for tackling complex
                  challenges and poised to contribute to solutions, scalable
                  software systems, and impactful projects in software
                  development
                </p>
                <h2>Interests</h2>
                <ul>
                  <li>MERN Development</li>
                  <li>GenAI</li>
                  <li>Blogging</li>
                  <li>Debugging</li>
                </ul>
                <h2>Technical Skills</h2>
                <table className="table-macos">
                  <th>Technology</th>
                  <th>Languages/Skills</th>
                  <tr>
                    <td>Programming Languages</td>
                    <td>Java, Python, C, C++</td>
                  </tr>
                  <tr>
                    <td>Web Technologies</td>
                    <td>
                      Html, CSS, Bootstrap, JavaScript, React JS, Email JS
                    </td>
                  </tr>
                  <tr>
                    <td>Version Control</td>
                    <td>Git, GitHub, GitHub Actions, Pages</td>
                  </tr>
                  <tr>
                    <td>Database System</td>
                    <td>MySQL, MongoDB</td>
                  </tr>
                  <tr>
                    <td>GenAI</td>
                    <td>
                      Large Language Models, Retrieval Agumented , Gemini API,
                      LangChain, Fine Tuning
                    </td>
                  </tr>
                  <tr>
                    <td>Core Skills</td>
                    <td>
                      Data Structure & Algorithms, Operating System, System
                      Design
                    </td>
                  </tr>
                </table>
                <h2>Hobbies</h2>
                <ol type="1">
                  <li>To unwind after a productive day, I enjoy honing my cloud skills with Google Cloud Arcade games</li>
                  <li>I contribute to the developer community by authoring technical articles for Hashnode, a leading developer-focused content platform</li>
                </ol>
              </div>
            </Container>
          </div>
        </div>
      </div>
    </Draggable>
  );
}
